(() => {
  const initialize = () => document.querySelectorAll('[data-vaulted-native-root]').forEach(root => {
    if (root.dataset.nativeReady) return;
    root.dataset.nativeReady = 'true';
    const form = root.querySelector('form');
    const success = root.querySelector('[data-native-success]');
    if (success) {
      const revealSuccess = () => {
        success.focus({ preventScroll: true });
        success.scrollIntoView({ behavior: 'instant', block: 'start' });
      };
      revealSuccess();
      window.addEventListener('load', revealSuccess, { once: true });
      window.addEventListener('pageshow', revealSuccess);
      requestAnimationFrame(() => requestAnimationFrame(revealSuccess));
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('contact_posted');
      currentUrl.hash = '';
      history.replaceState(history.state, '', currentUrl.toString());
      return;
    }
    const pending = root.querySelector('[data-native-pending]');
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      pending.hidden = false;
      form.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => {
      pending.hidden = true;
      form.removeAttribute('aria-busy');
    });
    const phone = root.querySelector('[data-native-phone]');
    if (!phone) return;
    const contact = root.querySelector('[data-native-contact]');
    const sms = root.querySelector('[data-native-sms]');
    const sourcing = root.querySelector('[data-native-sourcing]');
    const update = () => {
      const waitlist = form.querySelector('input[name="contact[Request type]"]:checked').value === 'Join waitlist';
      sourcing.hidden = waitlist;
      sourcing.disabled = waitlist;
      phone.required = contact.value !== 'Email' || sms.checked;
    };
    form.addEventListener('change', update);
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
